/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from 'react-toolbox/lib/button';

import { DropdownDiv, ContainerDiv } from './styledComponents';
import { CHECKLIST_BASIC_YES_NO_LISTS } from 'config/constants';
import S from '../styles.scss';

const renderList = list => (<ul className={S.scriptList}>
  {list.map(i => <li key={i}>{i}</li>)}
</ul>);

const renderNoteLists = showKey => (<Fragment>
  {CHECKLIST_BASIC_YES_NO_LISTS[showKey].can.length > 0 && <Fragment>
    <p>We will:</p>
    {renderList(CHECKLIST_BASIC_YES_NO_LISTS[showKey].can)}
  </Fragment>}
  {CHECKLIST_BASIC_YES_NO_LISTS[showKey].cannot.length > 0 && <Fragment>
    <p>We cannot:</p>
    {renderList(CHECKLIST_BASIC_YES_NO_LISTS[showKey].cannot)}
  </Fragment>}
</Fragment>);

const BasicYesNoQuestion = ({
  parentAnswer, canShow, showKey, showNote, yesDisabled, noDisabled, handleAnswered,
}) => <Fragment>
  {canShow && <ContainerDiv>
    <DropdownDiv condition={canShow}>
      <div className={S.checklistContainer}>
        <p>
          {parentAnswer === 'yes' ? '' : CHECKLIST_BASIC_YES_NO_LISTS[showKey].intro.prefix}
          {CHECKLIST_BASIC_YES_NO_LISTS[showKey].intro.base}
        </p>
        <br />
        <Button
          label="YES"
          flat inverse ripple
          disabled={yesDisabled}
          className={S.standardButton}
          onClick={() => handleAnswered(showKey, false, 'yes')}
        />
        <Button
          label="NO"
          flat inverse ripple
          disabled={noDisabled}
          className={S.standardButton}
          onClick={() => handleAnswered(showKey, true, 'no')}
        />
        <br />
        <br />
        {showNote && <ContainerDiv>
          <DropdownDiv condition={showNote}>
            {renderNoteLists(showKey)}
          </DropdownDiv>
        </ContainerDiv>}
      </div>
    </DropdownDiv>
  </ContainerDiv>}
</Fragment>;

BasicYesNoQuestion.propTypes = {
  parentAnswer: PropTypes.string,
  canShow: PropTypes.bool,
  yesDisabled: PropTypes.bool,
  noDisabled: PropTypes.bool,
  handleAnswered: PropTypes.func,
  showKey: PropTypes.string,
  showNote: PropTypes.bool,
};

export default BasicYesNoQuestion;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/basicYesNoQuestion.jsx